module.exports = __webpack_public_path__ + "static/media/8.716adce3.png";